import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPencil: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pencil, edit, write"><path d="M14.7197 3.72001C16.2552 2.18448 18.7448 2.18448 20.2803 3.72001C21.8159 5.25554 21.8159 7.74514 20.2803 9.28067L8.36612 21.1949C7.85039 21.7106 7.15092 22.0003 6.42157 22.0003H2.75C2.33579 22.0003 2 21.6646 2 21.2503V17.5788C2 16.8494 2.28973 16.1499 2.80546 15.6342L12.1895 6.25017L17.75 11.8107L18.8107 10.75L13.2502 5.18951L14.7197 3.72001Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPencil;
